import { Component, OnInit } from '@angular/core'
import { LoadingService } from './services/loading.service'
import { AuthService } from './services/auth.service'
import { Router } from '@angular/router'
import { NavbarService } from './services/navbar.service'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'client'
  isLoading = false

  constructor(public loadingService: LoadingService, public authService: AuthService, public router: Router) { }

  ngOnInit() {
  }
}
